import { useQuery } from '@tanstack/react-query'
import { useCurrentProject } from 'src/providers/current-project.provider'
import { ProjectService } from 'src/services/project.service'
import { TMedAlert } from 'src/types/med-alert'

export function useProjectMedAlerts() {
  const { project } = useCurrentProject()

  return useQuery<TMedAlert[]>({
    queryKey: ['medAlerts', project?.id],
    queryFn: () => ProjectService.getMedAlerts(project!.id),
    enabled: !!project?.id,
  })
}
